import React from "react";

import styled from "@emotion/styled";

const ArrowRightIcon = ({ color = "#f0f0f0" }) => {
    const SVG = styled.svg`
        fill: ${color};
    `;
    return (
        <SVG
            version="1.1"
            id="Ebene_1"
            x="0px"
            y="0px"
            viewBox="0 0 49.9 50.9"
            xmlSpace="preserve"
        >
            <path
                id="Polygon_1"
                className="st0"
                d="M23.1,8.2c0.4-1,1.5-1.6,2.6-1.2c0.6,0.2,1,0.6,1.2,1.2l3.5,9.8c0.3,0.8,1,1.3,1.8,1.3l10.4,0.3
	c1.1,0,2,0.9,1.9,2.1c0,0.6-0.3,1.2-0.8,1.5l-8.2,6.3c-0.7,0.5-0.9,1.4-0.7,2.2l2.9,9.9c0.3,1.1-0.3,2.2-1.4,2.5
	c-0.6,0.2-1.2,0.1-1.7-0.3l-8.6-5.9c-0.7-0.5-1.6-0.5-2.3,0l-8.6,5.9c-0.9,0.6-2.2,0.4-2.8-0.5c-0.3-0.5-0.4-1.1-0.3-1.7l2.9-9.9
	c0.2-0.8,0-1.7-0.7-2.2l-8.2-6.3c-0.9-0.7-1-1.9-0.4-2.8c0.4-0.5,0.9-0.8,1.5-0.8l10.4-0.3c0.8,0,1.6-0.6,1.8-1.3L23.1,8.2z"
            />
        </SVG>
    );
};

export default ArrowRightIcon;
